/* eslint-disable no-duplicate-case */
/* eslint-disable no-fallthrough */
import * as types from "./actionType";

const initialState = {
    screenWidth: 0,
    aiFrameWork: {},
    loginStatus: false,
    // sign up
    countryCodeDropdown: [],
    getGeneratedToken: {},
    validateGeneratedToken: {},
    expiryStatus: false,
    // sign up

    // #region dashboard page
    subscribed_user: {},
    subscriber_graph_data: {},
    subscriber_by_plan: [],
    recent_users: [],
    session_logins: [],
    apollo_credit_data: {},

    get_uplaoads: [],
    get_total_couts: [],
    subscriptions: [],
    loginDetails: [],
    userActivityData: [],
    userDownloadData: [],
    countryGraph: [],
    mapGraph: [],
    industryGraph: [],
    recentSearch: [],
    getCredits: {},
    uploadStatsBarChartData: [],
    // #endregion

    // search contacts
    jobLevelDropdown: [],
    previousJobLevelDropdown: [],
    jobFunctionDropdown: [],
    technologyDropdown: [],
    previousTechnologyDropdown: [],
    subIndustriesDropdown: [],
    previousSubIndustriesDropdown: [],
    countryNameDropdown: [],
    searchedContactData: [],
    stateDropdownData: [],
    cityDropdownData: [],
    phoneEmailUnlockedData: [],
    getListName: [],
    getContinents: [],
    // search contacts

    // viewed contacts
    getViewedContacts: [],
    getRecentContacts: [],
    downloadViewedData: [],
    unlockAllContacts: [],
    // viewed contacts

    // Settings Trash
    trashedData: [],
    // Settings Trash

    // Saved Searches
    savedSearchData: [],
    // Saved Searches

    // Settings Users
    usersData: [],
    // Settings Users

    // Report
    // Data Count
    reportDataCountryCount: [],
    reportDataIndustryCount: [],
    industryDropdown: [],
    // Data Count
    // Report

    // Total Data Count
    totalDataCount: null,
    // Total Data Count

    // #region upload data page
    getDataReport: {},
    getUploadUser: [],
    // #enregion

    // Profile
    profileData: {},
    // Profile

    // My List
    myListData: [],
    // My List
    isAiOpen: false,
    openAiLoader: false,

    loading: true,
};

const designReducers = (state = initialState, action) => {
    switch (action.type) {
        case types.get_screen_width:
            return {
                ...state,
                screenWidth: action.payload,
                loading: false,
            };
        case types.get_Ai_framework:
            return {
                ...state,
                aiFrameWork: action.payload,
                loading: false,
            };
        case types.get_login_status:
            return {
                ...state,
                loginStatus: action.payload,
                loading: false,
            };
        // sign up
        case types.post_SignUp_Data:
        case types.google_SignUp_Login:
        case types.get_CountryCode_Dropdown_Data:
            return {
                ...state,
                countryCodeDropdown: action.payload,
                loading: false,
            };
        // sign up

        // sign in
        case types.post_SignIn_Data:
        case types.get_Generated_Token:
            return {
                ...state,
                getGeneratedToken: action.payload,
                loading: false,
            };
        case types.validate_Generated_Token:
            return {
                ...state,
                validateGeneratedToken: action.payload,
                loading: false,
            };
        // sign in

        // #region upload page
        case types.get_upload_details:

            return {
                ...state,
                get_uplaoads: action.payload,
                loading: false,
            };
        // #endregion

        // Dashboard data
        case types.get_subscribed_user_data:
            return {
                ...state,
                subscribed_user: action.payload,
                loading: false
            }
        case types.get_subscriber_graph_data:
            return {
                ...state,
                subscriber_graph_data: action.payload,
                loading: false
            }
        case types.get_subscriber_by_plan:
            return {
                ...state,
                subscriber_by_plan: action.payload,
                loading: false
            }
        case types.get_recent_users:
            return {
                ...state,
                recent_users: action.payload,
                loading: false
            }

        case types.get_session_logins:
            return {
                ...state,
                session_logins: action.payload,
                loading: false
            }
        case types.get_ap_credits:
            return {
                ...state,
                apollo_credit_data: action.payload,
                loading: false
            }
        case types.get_counts:
            return {
                ...state,
                get_total_couts: action.payload,
                loading: false
            }
        case types.get_subscription:
            return {
                ...state,
                subscriptions: action.payload,
                loading: false
            }
        case types.get_login_details:
            return {
                ...state,
                loginDetails: action.payload,
                loading: false
            }
        case types.get_user_activity:
            return {
                ...state,
                userActivityData: action.payload,
                loading: false
            }
        case types.get_download_activity:
            return {
                ...state,
                userDownloadData: action.payload,
                loading: false
            }
        case types.get_country_graph:
            return {
                ...state,
                countryGraph: action.payload,
                loading: false
            }
        case types.get_map_graph:
            return {
                ...state,
                mapGraph: action.payload,
                loading: false
            }
        case types.get_industry_graph:
            return {
                ...state,
                industryGraph: action.payload,
                loading: false
            }
        case types.get_recent_search:
            return {
                ...state,
                recentSearch: action.payload,
                loading: false
            }
        case types.get_credits:
            return {
                ...state,
                getCredits: action.payload,
                loading: false
            }
        case types.get_Upload_Stats_BarChart_Data:
            return {
                ...state,
                uploadStatsBarChartData: action.payload,
                loading: false
            }
        // Dashboard data

        // search contacts
        case types.post_Search_Data_Count:
        case types.get_Search_Contact_Data:
        case types.get_JobLevel_Dropdown:
            return {
                ...state,
                jobLevelDropdown: action.payload,
                loading: false,
            };
        case types.get_preJobLevel_Dropdown:
            return {
                ...state,
                previousJobLevelDropdown: action.payload,
                loading: false,
            };
        case types.get_Job_Function_Dropdown:
            return {
                ...state,
                jobFunctionDropdown: action.payload,
                loading: false,
            };
        case types.get_Technology_Dropdown:
            return {
                ...state,
                technologyDropdown: action.payload,
                loading: false,
            };
        case types.get_previousTechnology_Dropdown:
            return {
                ...state,
                previousTechnologyDropdown: action.payload,
                loading: false,
            };
        case types.get_SubIndustries_Dropdown:
            return {
                ...state,
                subIndustriesDropdown: action.payload,
                loading: false,
            };
        case types.get_previousSubIndustry_Dropdown:
            return {
                ...state,
                previousSubIndustriesDropdown: action.payload,
                loading: false,
            };
        case types.get_CountryName_Dropdown:
            return {
                ...state,
                countryNameDropdown: action.payload,
                loading: false,
            };
        case types.get_Searched_Contact_Data:
            return {
                ...state,
                searchedContactData: action.payload,
                loading: false,
            };
        case types.get_StateDropdown_BasedOnCountry:
            return {
                ...state,
                stateDropdownData: action.payload,
                loading: false,
            };
        case types.get_CityDropdown_BasedOnState:
            return {
                ...state,
                cityDropdownData: action.payload,
                loading: false,
            };
        case types.post_Phone_Unlock_Data:
        case types.get_Phone_Email_Unlocked_Data:
            return {
                ...state,
                phoneEmailUnlockedData: action.payload,
                loading: false,
            }
        case types.post_Save_Search_Data:
        case types.get_List_Name:
            return {
                ...state,
                getListName: action.payload,
                loading: false,
            }
        case types.post_Save_Search_Data:
        case types.get_Continent_Dropdown:
            return {
                ...state,
                getContinents: action.payload,
                loading: false,
            }
        // search contacts

        // viewed contacts
        case types.get_Viewed_Contacts_Data:
            return {
                ...state,
                getViewedContacts: action.payload.length === 0
                    ? []
                    : [
                        ...state.getViewedContacts,
                        ...action.payload
                    ],
                loading: false,
            };
        case types.get_Recent_Contacts_Data:
            return {
                ...state,
                getRecentContacts: action.payload,
                loading: false,
            };
        case types.download_Viewed_Contacts_Data:
            return {
                ...state,
                downloadViewedData: action.payload,
                loading: false,
            }
        case types.get_Update_Viewed_Contacts:
            return {
                ...state,
                getViewedContacts: action.payload,
                loading: false,
            }
        case types.unlock_All_Contacts:
            return {
                ...state,
                unlockAllContacts: action.payload,
                loading: false,
            }
        case types.post_Delete_Viewed_Contacts_Data:
        // viewed contacts

        // Settings Trash
        case types.restore_All_Data:
        case types.delete_trashed_Data:
        case types.get_Trashed_Data:
            return {
                ...state,
                trashedData: action.payload,
                loading: false,
            };
        // Settings Trash

        // Saved Searches
        case types.get_Saved_Searches_Data:
            return {
                ...state,
                savedSearchData: action.payload,
                loading: false,
            }
        case types.edit_Saved_Searches_Data:
        case types.delete_Saved_Searches_Data:
        // Saved Searches

        // Settings Users
        case types.get_Users_Data:
            return {
                ...state,
                usersData: action.payload,
                loading: false,
            }
        case types.post_Users_Data:
        // Settings Users

        // Report
        // Data Count
        case types.get_Report_Country_Data_Count:
            return {
                ...state,
                reportDataCountryCount: action.payload,
                loading: false,
            }
        case types.get_Report_Industry_Data_Count:
            return {
                ...state,
                reportDataIndustryCount: action.payload,
                loading: false,
            }
        case types.get_Industry_Dropdown:
            return {
                ...state,
                industryDropdown: action.payload,
                loading: false,
            }
        // Data Count
        // Report

        // Total Data Count
        case types.Get_Total_Data_Count:
            return {
                ...state,
                totalDataCount: action.payload,
                loading: false,
            };
        // Total Data Count

        // #region data report page
        case types.Get_Upload_Report:
            return {
                ...state,
                getDataReport: action.payload,
                loading: false
            }
        case types.get_upload_user:
            return {
                ...state,
                getUploadUser: action.payload,
                loading: false
            }
        // #endregion

        // Reset Password
        case types.post_Reset_Password_Data:
        // Reset Password

        // Forgot Password
        case types.send_Forgot_Password_Email:
        // Forgot Password

        // Profile
        case types.get_Profile_Data:
            return {
                ...state,
                profileData: action.payload,
                loading: false
            }
        case types.post_Profile_Data:
        // Profile

        // My List
        case types.update_My_List_Data:
        case types.delete_My_List_Data:
        case types.get_My_List_Data:
            return {
                ...state,
                myListData: action.payload,
                loading: false
            }
        // My List

        case "Open_Ai_Modal":

            return {
                ...state,
                isAiOpen: action.payload,
                loading: false,
            };
        case "Open_Ai_Loader":

            return {
                ...state,
                openAiLoader: action.payload,
                loading: false,
            };

        default:
            return state;
    }
};

export default designReducers;
